<template>
  <v-container fluid grid-list-lg pa-0>
    <v-autocomplete
      v-model="selectedValues"
      :items="itemList"
      item-text="name"
      item-value="id"
      hide-no-data
      hide-selected
      :counter="maxSelected"
      :menu-props="menuProps"
      multiple
      chips
      deletable-chips
      small-chips
      @input="handleSelect"
    ></v-autocomplete>
  </v-container>
</template>

<script>
const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "LimitedDropdownSelector.vue",
  props: {
    maxSelected: {
      type: Number,
      require: true,
    },
    itemList: {
      type: Array,
      require: true,
    },
    defaultSelectedItemsIds: {
      type: Array,
      require: false,
    },
  },
  data() {
    return {
      menuProps: {
        disabled: false,
      },
      selectedValues: [],
    };
  },
  computed: {
    computedCounterValue() {
      let totalCount = 0;
      if (this.selectedValues && this.selectedValues.length > 0) {
        const selectedItems = this.selectedValues.map((id) => {
          return this.itemList.find((element) => element.id == id);
        });
        totalCount = selectedItems.reduce(function (prev, cur) {
          return prev + (cur.count ? cur.count : 1);
        }, 0);
      }
      return totalCount;
    },
  },
  mounted() {
    if (this.defaultSelectedItemsIds) {
      this.selectedValues = JSON.parse(
        JSON.stringify(this.defaultSelectedItemsIds)
      );
      this.handleSelect();
    }
  },
  methods: {
    handleSelect: function () {
      if (this.computedCounterValue >= this.maxSelected) {
        this.menuProps.disabled = true;
      } else {
        this.menuProps.disabled = false;
      }
      this.$emit(EMITTED_ACTIONS.CHANGE, this.selectedValues);
    },
  },
};
</script>

<style scoped></style>
